<template>
  <div class="nav-item">
    <span
      v-if="!isSideNav"
      :class="[{ isActive: isActive }]"
      class="nav-link"
      @click.prevent="navClickHandler"
    >
      <v-icon v-if="icon" size="22" color="black" class="ml-1" :icon="icon" />
      {{ title }}
    </span>
    <listItem
      v-else
      :isSubListItem="isSubCategory"
      :title="title"
      :isActive="isActive"
      :icon="icon"
      @click.prevent="navClickHandler"
    />
  </div>
</template>

<script>
import listItem from "../../UI/modals/list-item.vue";
import { mapGetters } from "vuex";
export default {
  emits: ["onNavLinkClick"],
  components: { listItem },
  props: {
    title: {
      type: String,
    },
    isSubCategory: {
      type: Boolean,
      default: false,
    },
    navigationName: {
      type: String,
    },
    icon: {
      type: String,
      default: null,
    },
    isSideNav: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
  },
  methods: {
    navClickHandler() {
      this.$emit("onNavLinkClick");
    },
  },
};
</script>

<style lang="scss">
.nav-link:hover {
  .v-icon {
    color: white !important;
  }
}
</style>

<style scoped lang="scss">
.nav-item {
  display: inline;
}
@media (max-width: 1440px) {
  .nav-link {
    cursor: pointer;
    padding: 25px 20px;
    font-size: 17px !important;
  }
}
.nav-link {
  cursor: pointer;
  padding: 25px 20px;
  font-size: $mediumTextSize;
  &.isActive  {
    background-color: $primaryColor;
    color: white !important;
    height: 100%;
      .v-icon {
    color: white !important;
  }
  }
}
.nav-link:hover {
  background-color: $primaryColor;
  color: white !important;
  height: 100%;
}
</style>
